import { apiConfig } from '../client/config';

/**
 * Media service – builds URLs for the User Media Controller getImage endpoint.
 * Use these URLs as img src so listing images load from the API.
 */
export class MediaService {
  private static readonly IMAGE_PATH = '/api/media/image';

  /**
   * Returns the full URL for GET /api/media/image?src=...
   * Use as img src for listing thumbnails when the API returns an image id/path instead of a full URL.
   */
  static getImageUrl(src: string | number): string {
    const base = apiConfig.baseURL.replace(/\/$/, '');
    const path = MediaService.IMAGE_PATH;
    const encoded = encodeURIComponent(String(src));
    return `${base}${path}?src=${encoded}`;
  }

  /**
   * Returns a URL suitable for img src.
   * If the given value is already an absolute URL (http/https), returns it as is.
   * Otherwise treats it as a media src and returns the getImage endpoint URL.
   */
  static toImageSrc(value: string | number | null | undefined): string {
    if (value == null || value === '') return '';
    const s = String(value).trim();
    if (s.startsWith('http://') || s.startsWith('https://')) return s;
    return MediaService.getImageUrl(s);
  }
}
